module.exports = "/_next/static/images/adee0736bd103ae2439d495d0beb737e-phone@1x.png.webp";